
<template>
  <div class="section">
    <div class="section-head">
      <img src="~@/assets/img/itles-webapp-videoClass/title-rq.png" alt />
    </div>
    <img src="~@/assets/img/itles-webapp-videoClass/rq-caption.png" alt class="bg" />
    <div class="section-conect">
      <ul>
        <li v-for="(item,index) in list" :key="index" class="item">
          <span class="item-location"></span>
          <span class="item-title">{{item.title}}：</span>
          <p class="item-des">{{item.desc}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  props:['list'],
  data() {
    return {
    };
  }
};
</script>
<style lang="scss" scoped>
.section-head {
  img {
    display: block;
    width: tovw(368);
    height: tovw(48);
    margin: tovw(40) auto;
    margin-top: tovw(80);
  }
}
.bg {
  display: block;
  width: 100%;
  height: tovw(160);
  margin: 0 auto;
}
.section-conect {
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.04);
  border-radius: tovw(24);
  padding: tovw(52) tovw(40) tovw(52) 0;

  .item {
    overflow: hidden;
    line-height: tovw(48);
    position: relative;
    padding-left: tovw(84);
    margin-bottom: tovw(52);
    .item-title {
      float: left;
      margin-right: tovw(12);
      font-size: tovw(32);
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
    }
    .item-des {
      font-size: tovw(32);
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 300;
      color: rgba(0, 0, 0, 0.8);
    }
    .item-location {
      position: absolute;
      display: block;
      width: tovw(40);
      height: tovw(40);
      top: tovw(6);
      left: tovw(24);
      background: url(~@/assets/img/itles-webapp-videoClass/icon-location.png)
        no-repeat;
      background-size: 100% 100%;
    }
  }
  .item:last-child {
    margin-bottom: 0;
  }
}
</style>